import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Btn,
  CustomPanel,
  ImageContainer,
  InputText,
  PageHeader,
  UploadFileBtn,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  assocNotaFiscalClienteWithDeliveryStep,
  buscarNotaCliente,
  newAssocNotaFiscalClienteWithDeliveryStep,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { urlUploadNfDevolucaoParcial } from '../../../../services/api/routes/receive-vehicle.routes'
import { deleteFileNotaFiscalDevolucaoParcial } from '../../../../services/api/https/processos/nf-devolucao-parcial.http'

function NotaFiscalCliente({ history, dispatch }) {
  // Vars
  const { selectedInvoice, step_id, client_id } = history.location.state

  // Hooks
  const [isLoadingBtnBuscar, setIsLoadingBtnBuscar] = useState(false)
  const [isLoadingBtnSalvar, setIsLoadingBtnSalvar] = useState(false)
  const [showUploadButton, setShowUploadButton] = useState(false)
  const [showSalvarButton, setShowSalvarButton] = useState(false)
  const [invoice, setInvoice] = useState(
    selectedInvoice
      ? { id: selectedInvoice.invoice_id, ...selectedInvoice }
      : { invoice_number: '' },
  )
  const [showImage, setShowImage] = useState(!!selectedInvoice)
  // Events
  const onBtnBuscarClick = async () => {
    try {
      setIsLoadingBtnBuscar(true)
      setShowImage(false)
      setShowSalvarButton(false)
      setShowUploadButton(false)

      if (invoice.invoice_number.trim() === '')
        throw Error('Preencha o Numero da Nota Fiscal e tente novamente.')
      else {
        const fetchedInvoice = await buscarNotaCliente(invoice.invoice_number, step_id)
        if (fetchedInvoice) {
          setInvoice(fetchedInvoice)
          setShowSalvarButton(true)
          setShowImage(true)
        } else {
          setShowUploadButton(true)
        }
      }
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoadingBtnBuscar(false)
    }
  }

  const onBtnSalvarClick = async () => {
    try {
      setIsLoadingBtnSalvar(true)
      await assocNotaFiscalClienteWithDeliveryStep(step_id, invoice.id)
      dispatch(showMessageBox('Nota Salva com sucesso', null))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoadingBtnSalvar(false)
    }
  }

  const onApagarImage = async () => {
    try {
      const path_array = invoice.invoice_path.split('/')
      const file_name = path_array[path_array.length - 1]
      await deleteFileNotaFiscalDevolucaoParcial(file_name, invoice.id, step_id)
      setInvoice({ invoice_number: '' })
      setShowImage(false)
      setShowUploadButton(false)
      setShowSalvarButton(false)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onUploadCompleted = async file_name => {
    try {
      const fetchedInvoice = await newAssocNotaFiscalClienteWithDeliveryStep(
        step_id,
        invoice.invoice_number,
        file_name,
      )
      setInvoice(fetchedInvoice)
      setShowImage(true)
      dispatch(showMessageBox('Nota Salva com sucesso', null))
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }
  // Helpers

  // Render
  return (
    <div>
      <PageHeader>
        {selectedInvoice ? <strong>Editando</strong> : <strong>Nova</strong>}
        &nbsp; NF Cliente
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onVoltar={history.goBack} showBtnNovo={false}>
          <div className="p-grid">
            <div className="p-col-2">
              <InputText
                label="Número da Nota Fiscal"
                value={invoice.invoice_number}
                onChange={value => setInvoice({ ...invoice, invoice_number: value })}
                marginTop={10}
              />
            </div>
            <div className="p-col-1" style={{ paddingTop: 35 }}>
              <Btn isLoading={isLoadingBtnBuscar} onClick={onBtnBuscarClick}>
                Buscar Nota
              </Btn>
            </div>
            <div
              className="p-col-1"
              style={{ paddingTop: 35, display: showSalvarButton ? 'block' : 'none' }}
            >
              <Btn isLoading={isLoadingBtnSalvar} onClick={onBtnSalvarClick}>
                Salvar
              </Btn>
            </div>
            <div
              className="p-col-fixed"
              style={{ paddingTop: 35, display: showUploadButton ? 'block' : 'none', width: 200 }}
            >
              <UploadFileBtn
                accept="image/*"
                label="Upload Nota Fiscal"
                name="nf-dev-parcial"
                url={urlUploadNfDevolucaoParcial(client_id, invoice.invoice_number)}
                onUploadCompleted={onUploadCompleted}
              />
            </div>
            <div
              className="p-col-4"
              style={{
                paddingTop: 35,
                display: showUploadButton ? 'block' : 'none',
                fontWeight: 'bold',
              }}
            >
              <p style={{ marginTop: 10 }}>
                Somente imagens (.jpg, .jpeg e .png) podem ser carregadas.
              </p>
            </div>
          </div>
          {showImage ? (
            <div style={{ marginTop: 15 }}>
              <ImageContainer onBtnDeleteClicked={onApagarImage} imagePath={invoice.invoice_path} />
            </div>
          ) : null}
        </CustomPanel>
      </div>
    </div>
  )
}

export default connect()(withRouter(NotaFiscalCliente))
